import type { ValueSerializer } from "type-route";
import { createRouter, defineRoute, noMatch, param } from "type-route";
import { makeThisModuleAnExecutableRouteLister } from "github-pages-plugin-for-type-route";
import { id } from "tsafe/id";
import type { EducationalResourceCategory } from "lib/educationalResources";
import { assert, Equals } from "tsafe";
import { getEnumValueSerializer } from "./tools/getEnumValueSerializer";

export const routeDefs = {
    "home": defineRoute("/"),
    "documentation": defineRoute(
        {
            "search": param.query.optional.string.default(""),
            "category": param.query.optional.ofType(
                getEnumValueSerializer(
                    (() => {
                        const educationalResourceCategories = [
                            "Ocean modelling",
                            "Ocean data quality",
                            "Data visualization",
                            "What-If applications",
                            "Focus applications",
                            "discover EDITO",
                            "training courses with R",
                            "training courses with python",
                            "training courses in data science",
                            "best practices",
                        ] as const;

                        assert<
                            Equals<
                                EducationalResourceCategory,
                                (typeof educationalResourceCategories)[number]
                            >
                        >();

                        return educationalResourceCategories;
                    })(),
                ),
            ),
            "path": param.query.optional
                .ofType(
                    id<ValueSerializer<string[]>>({
                        "parse": raw => {
                            try {
                                return JSON.parse(raw) as string[];
                            } catch {
                                return noMatch;
                            }
                        },
                        "stringify": value => JSON.stringify(value),
                    }),
                )
                .default([]),
        },
        () => "/training",
    ),
};

makeThisModuleAnExecutableRouteLister(routeDefs);

export const { RouteProvider, useRoute, routes } = createRouter(
    { "scrollToTop": false },
    routeDefs,
);
